import axios from 'axios';
import { stagingBaseUrlFromWindow } from './base-url-staging';
import { baseUrlFromWindow } from './base-url';
import getCsrfToken from './csrf';
import { AxiosRequestConfig } from 'axios';

/**
 * nextjs apps can be run locally but be configured to call active staging rather than active localhost.
 * If client is called by a microfrontend mounted by a nextjs app, `useStagingApi` can be passed in to
 * the mfe's props from `process.env.USE_STAGING_API` so it uses the same baseurl as the nextjs app's other
 * api requests.
 */

const apiClient = ({
  useStagingApi = typeof process !== 'undefined'
    ? process?.env?.USE_STAGING_API
    : false,
  currentLanguage = 'en-US',
  options = {} as AxiosRequestConfig
} = {}) => {
  const { headers: optionalHeaders, ...moreOptions } = options;
  const config = {
    baseURL: useStagingApi ? stagingBaseUrlFromWindow() : baseUrlFromWindow(),
    withCredentials: true,
    timeout: 30000, // 30 seconds
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept-Language': currentLanguage,
      ...optionalHeaders
    },
    ...moreOptions
  };

  const csrfToken = getCsrfToken();
  if (csrfToken) {
    config.headers = { 'x-csrf-token': csrfToken, ...config.headers };
  }

  return axios.create(config);
};

export default apiClient;
